import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActiveFilter } from "../../../../models/Table/ActiveFilter";
import { TableHeader } from "../../../../models/Table/TableHeader";
import { ReservationService } from "../../../../core/services/reservations/reservation.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActiveFiltersComponent } from "../active-filters/active-filters.component";
import { AuthFormInputDirective } from "../../../directives/auth/auth-form-input.directive";
import { CalendarModule } from "primeng/calendar";
import { LoaderComponent } from "../../loader/loader.component";
import { MultiSelectModule } from "primeng/multiselect";
import { NgClass, NgForOf, NgIf, NgTemplateOutlet } from "@angular/common";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { Filter } from "../../../../models/Table/Filter";
import { filter } from "rxjs";
import { TableBulkActionsComponent } from "../table-bulk-actions/table-bulk-actions.component";
import { Reservation } from "../../../../models/Reservation";
import { PrimeNGConfig } from "primeng/api";
import { AuthStateService } from '../../../../core/services/auth/auth-state.service';
import { Router, RouterLink } from '@angular/router';
import { BookFormService } from '../../../../core/services/book-form.service';
import { User } from '../../../../models/User';
import { Station } from '../../../../models/Station';
import { Service } from '../../../../models/Service';
import { Vehicle } from '../../../../models/Vehicle';
import { State } from '@ngrx/store';
import { RoleV2, UserV2 } from '../../../../models/UserV2';
import { RoleService } from "../../../../core/services/roles/role.service";
import { PaymentMethod } from '../../../../models/PaymentMethod';
import { Fuel } from '../../../../models/Fuel';


@Component({
  selector: 'app-table-filters',
  standalone: true,
  imports: [
    RouterLink,
    ActiveFiltersComponent,
    AuthFormInputDirective,
    CalendarModule,
    LoaderComponent,
    MultiSelectModule,
    NgForOf,
    NgIf,
    OverlayPanelModule,
    ReactiveFormsModule,
    FormsModule,
    TableBulkActionsComponent,
    NgTemplateOutlet,
    NgClass
  ],
  templateUrl: './table-filters.component.html',
})
export class TableFiltersComponent implements OnChanges {
  filtersForm: FormGroup;
  @Input() filters: ActiveFilter[] = [];
  @Input() filtersList: Filter[] = [];
  @Input() perPage!: number;
  @Input() perPageOptions: number[] = [];
  @Input() loading: boolean = false;
  @Input() displayNames: { [key: string]: string } | null = null;
  @Output() onChangeFilters: EventEmitter<ActiveFilter[]> = new EventEmitter<ActiveFilter[]>();
  @Input() reservationsCsv: Reservation[] | null = null;
  @Input() bulkActions: { label: string, key: string }[] = [];
  @Output() bulkActionClick: EventEmitter<string> = new EventEmitter<string>();

  @Output() onChangePerPage: EventEmitter<number> = new EventEmitter<number>();
  @Output() onChangeColumn: EventEmitter<TableHeader[]> = new EventEmitter<TableHeader[]>();
  @Input() tableHeaders: TableHeader[] = [];

  @Input() allInDropdown: boolean = true;
  @Input() maxSelectedDropdowns: number = 1;

  @Input() showColumnsAndPerPage: boolean = true;

  @Input() isCalendar: boolean = false;

  @Input() userStationsList: any[] = [];
  @Input() userRolesList: any[] = [];
  @Input() stations: any[] = [];
  @Input() roles: any[] = [];

  @Output() stationChanged = new EventEmitter<number[]>();
  @Output() roleChanged = new EventEmitter<number[]>();
  @Output() resetFilters: EventEmitter<void> = new EventEmitter<void>();
  @Output() searchChanged = new EventEmitter<string>();

  showFilters: boolean = false;

  isProfessional: boolean = false;

  user: User | null = null;

  today: Date = new Date();

  services: Service[] = [];
  vehicles: Vehicle[] = [];
  fuels: Fuel[] = [];
  users: UserV2[] = [];
  professionals: UserV2[] = [];
  selectedRolesIds: number | null = null;
  selectedStationsIds: number | null = null;
  paymentMethods: PaymentMethod[] = [];

  constructor(private fb: FormBuilder, private reservationService: ReservationService, private spinner: NgxSpinnerService,
    private primeNGConfig: PrimeNGConfig, private authStateService: AuthStateService, private bookFormService: BookFormService, private cdr: ChangeDetectorRef, private router: Router) {
    this.filtersForm = this.fb.group({})
    this.primeNGConfig.setTranslation({
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Borrar',
      firstDayOfWeek: 1 // Establecer el lunes como primer día de la semana
    });
    this.isProfessional = !this.authStateService.isNotProfessional();

    this.authStateService.currentUser.subscribe(data => {
      this.user = data;
    });
  }

  ngOnChanges(changes: SimpleChanges) {

    this.filtersList.forEach(filter => {
      this.filtersForm.addControl(filter.key, new FormControl(null));
    });
    const states = this.filtersList.find(filter => filter.key === 'station_id')?.multiSelectItems;
    if (states?.length) {
      states.forEach(state => {
        state.items.forEach((item: Station) => {
          if (!this.stations.some(s => s.id === item.id)) {
            this.stations.push(item);
          }
        });
      });
    }

    const services = this.filtersList.find(filter => filter.key === 'service_id')?.multiSelectItems;
    services?.forEach(service => {
      if (!this.services.some(s => s.id === service.id)) {
        this.services.push(service);
      }
    });

    const vehicles = this.filtersList.find(filter => filter.key === 'vehicle_id')?.multiSelectItems;
    if (vehicles?.length) {
      vehicles.forEach(vehicle => {
        if (!this.vehicles.some(v => v.id === vehicle.id)) {
          this.vehicles.push(vehicle);
        }
      });
    }

    const fuels = this.filtersList.find(filter => filter.key === 'fuel_id')?.multiSelectItems;
    if (fuels?.length) {
      fuels.forEach(fuel => {
        if (!this.fuels.some(f => f.id === fuel.id)) {
          this.fuels.push(fuel);
        }
      });
    }

    const paymentMethods = this.filtersList.find(filter => filter.key === 'payment_method_id')?.multiSelectItems;
    if (paymentMethods?.length) {
      paymentMethods.forEach(paymentMethod => {
        if (!this.paymentMethods.some(p => p.id === paymentMethod.id)) {
          this.paymentMethods.push(paymentMethod);
        }
      });
    }

    const users = this.filtersList.find(filter => filter.key === 'user_id')?.multiSelectItems;
    if (users?.length) {
      users.forEach(user => {
        if (!this.users.some(u => u.id === user.id)) {
          this.users.push(user);
        }
      });
    }

    const professionals = this.filtersList.find(filter => filter.key === 'professional_id')?.multiSelectItems;
    if (professionals?.length) {
      professionals.forEach(professional => {
        if (!this.professionals.some(p => p.id === professional.id)) {
          this.professionals.push(professional);
        }
      });
    }
    const roles = this.filtersList.find(filter => filter.key === 'role_id')?.multiSelectItems;
    if (roles?.length) {
      roles.forEach(role => {
        if (!this.roles?.some(r => r.id === role.id)) {
          this.roles?.push(role);
        }
      });
    }

    this.filters.forEach(filter => {
      this.patchFilter(filter);
    });
  }

  patchFilter(filter: ActiveFilter) {
    const patchObject = {};
    console.log(filter);
    // @ts-ignore
    if (filter.parsed === 'relationship-arr') {
      // @ts-ignore
      patchObject[filter.column] = filter.value.map(v => v[filter.relation_filter_column]);
    } else {
      // @ts-ignore
      patchObject[filter.column] = filter.value;
    }
    console.log(patchObject);
    this.filtersForm.patchValue(patchObject);
  }

  hasSearch() {
    // console.log(this.filtersList.filter(filter => {return filter.type === 'search'}).length);
    return this.filtersList.filter(filter => { return filter.type === 'search' }).length
  }
  searchItem() {
    return this.filtersList.filter(filter => { return filter.type === 'search' })[0];
  }

  search(): void {
    const formValues = this.filtersForm.value;
    if (this.router.url.includes('usuarios')) {

      if (this.selectedRolesIds || this.selectedStationsIds) {
        this.clearFilters();
      }

      const selectedStationIds = formValues['station_id'];
      const selectedRoleIds = formValues['role_id'];

      if (selectedStationIds) {
        this.stationChanged.emit(selectedStationIds.map((id: string) => Number(id)));
      }

      if (selectedRoleIds) {
        this.roleChanged.emit(selectedRoleIds.map((id: string) => Number(id)));
      }
    }
    const filters: ActiveFilter[] = [];
    this.filtersList.forEach(filter => {
      let id = formValues[filter.key];

      if (this.filtersList.some(filter => filter.type === 'date-between')) {
        if (filter.key === 'station_id') {
          id = Array.isArray(id)
            ? this.stations.filter(station => id.includes(station.id))
            : this.stations.filter(station => station.id === id);
        }
      }

      if (filter.key === 'service_id') {
        id = Array.isArray(id)
          ? this.services.filter(service => id.includes(service.id))
          : this.services.filter(service => service.id === id);
      }

      if (filter.key === 'vehicle_id') {
        id = Array.isArray(id)
          ? this.vehicles.filter(vehicle => id.includes(vehicle.id))
          : this.vehicles.filter(vehicle => vehicle.id === id);
      }

      if (filter.key === 'fuel_id') {
        id = Array.isArray(id)
          ? this.fuels.filter(fuel => id.includes(fuel.id))
          : this.fuels.filter(fuel => fuel.id === id);
      }

      if (filter.key === 'payment_method_id') {
        id = Array.isArray(id)
          ? this.paymentMethods.filter(paymentMethod => id.includes(paymentMethod.id))
          : this.paymentMethods.filter(paymentMethod => paymentMethod.id === id);
      }

      if (filter.key === 'user_id') {
        id = Array.isArray(id)
          ? this.users.filter(user => id.includes(user.id))
          : this.users.filter(user => user.id === id);
      }

      if (filter.key === 'professional_id') {
        id = Array.isArray(id)
          ? this.professionals.filter(professional => id.includes(professional.id))
          : this.professionals.filter(professional => professional.id === id);
      }

      if (filter.key === 'state') {
        id = Array.isArray(id) ? id : [id];
      }

      if (filter.key === 'date') {
        id = formValues[filter.key];
      }

      if (formValues[filter.key] && formValues[filter.key].length > 0) {
        let obj: any = {
          column: filter.key,
          operator: filter.operator,
          value: id,
        }
        if (this.router.url.includes('usuarios')) {
          if (obj.column === 'station_id') {
            obj.value = obj.value.map((stationId: number) => {
              return this.stations.find((station: Station) => station.id === stationId);
            })
          }

          if (obj.column === 'role_id') {
            obj.value = obj.value.map((roleId: number) => {
              return this.roles.find((role: RoleV2) => role.id === roleId);
            })
          }
        }

        if ((filter.parsed === 'relationship-arr' || filter.parsed == 'array')) {
          obj['parsed'] = filter.parsed;

          if (!obj['relation_column']) {
            obj['relation_column'] = filter.relation_column;
          }
          if (!obj['relation_filter_column']) {
            obj['relation_filter_column'] = filter.relation_filter_column;
          }
        } else if (filter.parsed === 'date-arr' || filter.parsed === 'date') {
          obj['parsed'] = filter.parsed;
          obj['format'] = 'dd/MM/yyyy';
        }

        filters.push(obj);
      }

      const storedFilters = JSON.parse(localStorage.getItem('itv_reservation_filters') || '[]');
      const lockedFilter = storedFilters.find((f: ActiveFilter) => f.column === 'locked');
      if (lockedFilter && (lockedFilter.value === 1 || lockedFilter.value === true)) {
        const alreadyLocked = filters.some(f => f.column === 'locked');
        if (!alreadyLocked) {
          filters.push({
            column: 'locked',
            operator: '=',
            value: 1
          });
        }
      }
    });

    this.onChangeFilters.emit(filters);
  }

  onSearchChanged(value: string) {
    this.searchChanged.emit(value);
  }
  onStationSelect(event: any) {
    this.stationChanged.emit([Number(event.target.value)]);
  }

  onRoleSelect(event: any) {
    this.roleChanged.emit([Number(event.target.value)]);
  }


  clearFilters(): void {
    this.filtersForm.reset();
    this.filters = [];
    this.resetFilters.emit();
    if (this.filtersList.some(filter => filter.type === 'date-between')) {
      this.filters.push({
        column: "date",
        format: "dd/MM/yyyy",
        operator: "between",
        parsed: "date-arr",
        value: [this.today, this.today]
      })
    }
    this.onChangeFilters.emit(this.filters);
  }

  public resetBookForm() {
    if (this.user && this.isProfessional) {
      this.bookFormService.resetProfessional({
        registration_number: this.user.profile.name
      }, { name: this.user.profile.name, email: this.user.profile.email, phone_number: this.user.profile.phone })
    } else {
      this.bookFormService.reset(undefined);
    }
  }
  getInputValue(event: Event): string {
    return (event.target as HTMLInputElement).value;
  }

  removeFilter(item: { pos: number; filter: ActiveFilter }): void {
    // Eliminar el filtro en la posición especificada
    this.filters.splice(item.pos, 1);

    // Establecer el valor del filtro eliminado a null
    item.filter.value = null;

    // Comprobar si hay algún filtro con la columna 'date'
    const hasDateFilter = this.filters.some(f => f.column === 'date');

    // Si no quedan filtros o no hay un filtro con 'date', añadir el filtro predeterminado
    if (this.filters.length === 0 || !hasDateFilter) {
      const defaultFilter: ActiveFilter = {
        column: "date",
        format: "dd/MM/yyyy",
        operator: "between",
        parsed: "date-arr",
        value: [this.today, this.today],
      };

      this.filters.push(defaultFilter);

      // Emitir el evento con los filtros actualizados
      this.onChangeFilters.emit(this.filters);

      // Actualizar el formulario con el filtro modificado (opcional)
      this.patchFilter(defaultFilter);
    } else {
      // Emitir el evento con los filtros actualizados
      this.onChangeFilters.emit(this.filters);

      // Actualizar el formulario con el filtro modificado (opcional)
      this.patchFilter(item.filter);
    }
  }
  onResetButtonClick() {

  }
  get showApplyDeleteButton(): boolean {
    return this.filters.length > 0 || this.filtersList.some(filter => filter.type === 'date-between') || this.filtersList.some(filter => filter.type !== 'search');
  }
}
